import * as React from "react";
import { forwardRef } from "react";
const SvgSelectClear = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 8, fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M5.5 5.5 L10.5 10.5 M10.5 5.5 L5.5 10.5", stroke: "var(--foreground-inverse)", strokeWidth: 1.5, strokeLinecap: "round", fill: "none" }));
const ForwardRef = forwardRef(SvgSelectClear);
export default ForwardRef;
